import Request from "../lib/request";
import config from "../common/config";

const http = new Request();
let token = localStorage.getItem("newToken");

export function uploadUrl() {
  return (config.host1 || "") + "/api/upload/file";
}

export function uploadImg() {
  return (config.host1 || "") + "/api/upload/image";
}

export default {
  //分类
  getColumnList(params) {
    return http.get(config.host1, "/api/news-article/column", params);
  },
  //子分类
  getColumnChildrenList(params) {
    return http.get(config.host1, "/api/news-article/column_children", params);
  },
  //列表
  getArticleList(params) {
    return http.get(config.host1, "/api/news-article/get", params);
  },
  //详情
  getArticleDetail(params) {
    return http.get(config.host1, "/api/news-article/detail", params);
  },
  //新增留言
  addComment(params) {
    return http.post(config.host1, "/v6/garden/user/user-message-save", params);
  },
  //验证码
  getCaptcha(params) {
    return http.get(config.host1, "/v6/common/user/captcha", params);
  },
  //单位详情
  getCompanyDetail(params) {
    return http.get(config.host1, "/v6/home/changsuo/danwei_info", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/home.api.js